export interface Ng4FilesConfig {
  acceptExtensions?: string[] | string;
  maxFilesCount?: number;
  maxFileSize?: number;
  totalFilesSize?: number;
}

/**
 * Author: Noraini A.Ghani
 * 
 * Date Created: July 24th 2018
 * 
 * Description: File Upoad Configuration
 **/
export const ng4FilesConfigDefault: Ng4FilesConfig = {
  acceptExtensions: '*',
  maxFilesCount: Infinity,
  maxFileSize: Infinity,
  totalFilesSize: Infinity
};



// WEBPACK FOOTER //
// ./src/app/ng4-files/declarations/ng4-files-config.ts